export default __webpack_public_path__ + "static/media/WildHillsMap.bc54bb0f.jpg";